import { memo } from 'react';
import { useMap } from 'react-map-gl/mapbox';
import Button from '~/components2/forms/Button';

const Zoom = memo(() => {
  const { current: map } = useMap();

  if (!map) return null;

  return (
    <div className="z-10 flex flex-col gap-2">
      <Button
        alternate
        icon="plus"
        iconSize={14}
        size="icon"
        onClick={() => map.zoomIn({})}
        aria-label="Zoom in"
        data-testid="map-zoom-in"
      />

      <Button
        alternate
        icon="minus"
        iconSize={14}
        size="icon"
        onClick={() => map.zoomOut({})}
        aria-label="Zoom out"
        data-testid="map-zoom-out"
      />
    </div>
  );
});

export default Zoom;
